




















































import { Component , Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import { InfoState } from '@/core';
const cssPrefix = 'image-upload';
@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
})
export default class ImageUpload extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showImageUpload: boolean;
  @Prop()
  tenantId : any;
  selectedFile : any = null;
  showError = false;
  created() {
    console.warn('this.dataCenter');
  }
  closeDialog() {
    this.$emit('close-dialog');
  }
  loadImage(event : any) {
    const extensions = event.target.files[0].name.split('.');
    console.warn(extensions[extensions.length - 1]);
    // tslint:disable-next-line:max-line-length
    if (extensions[extensions.length - 1].toLowerCase() === 'png' || extensions[extensions.length - 1].toLowerCase() === 'jpeg' || extensions[extensions.length - 1].toLowerCase() === 'svg' || extensions[extensions.length - 1].toLowerCase() === 'jpg') {
      this.showError = false;
      this.selectedFile = event.target.files[0];
    } else {
      this.showError = true;
      this.selectedFile = null;
    }
    console.warn(this.selectedFile);
    console.warn(event);
  }
  uploadImage() {
    const obj = {
      file : this.selectedFile,
      tenantId :this.tenantId,
    };
    this.$store.dispatch('SpogHomepageStoreModule/uploadImage', obj)
    .then((result) => {
      this.$store.commit('stopLoading', null, { root: true });
      console.warn(result);
      if (result.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: result.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.$emit('successMessage');
        this.closeDialog();
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: result.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }
}
